import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { BeraV2Service } from '@/infra/services/bera-v2';

import type { BeraSummaryResultV2 } from '@/types/Bera';

export interface GetBeraSummaryResultV2Params {
	id: string;
	organization_id: string;
	company_id: string;
	enabled?: boolean;
}

const Service = BeraV2Service.getInstance();

export function useGetBeraSummaryResultV2(params: GetBeraSummaryResultV2Params) {
	const hasValidIds = validateUuid([params.organization_id, params.company_id, params.id]);
	const enabled = hasValidIds && (params.enabled ?? true);

	return useQuery<BeraSummaryResultV2>({
		queryKey: [QUERY_KEYS.GET_BERA_SUMMARY_RESULT_V2, [params.organization_id, params.company_id, params.id]],
		queryFn: async () => Service.showJobSummaryResult(params),
		enabled,
		retry: 0
	});
}
